import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { path } from "../../../utils/common/constant";
import CheckPayment from "../../../assets/payment/check_payment.png";
import { useTranslation } from "react-i18next";

interface PaymentCompleteProps {
  paymentData: any;
}

const PaymentComplete: FC<PaymentCompleteProps> = ({ paymentData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(path.HOME);
    }, 7000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className=" flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-4 py-12">
        <div className="relative">
          {/* Center circle with check icon */}
          <div className="w-32 h-32 md:w-48 md:h-48 rounded-full flex items-center justify-center z-10 relative">
            <img src={CheckPayment} alt="complete payment" />
          </div>

          {/* Spinning dots container */}
          {/* <div className="absolute -inset-2 z-50">
            <div className="w-full h-full animate-spin-slow z-50">
              {[...Array(8)].map((_, index) => (
                <div
                  key={index}
                  className="absolute w-3 h-3 rounded-full bg-[#1e40af]"
                  style={{
                    top: "50%",
                    left: "50%",
                    transform: `rotate(${
                      index * 45
                    }deg) translate(-50%, -65px)`,
                  }}
                />
              ))}
            </div>
          </div> */}
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-[#1e40af] mt-8 mb-4">
          {t("payment_success.thank_you")}
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-800 mb-4">
          {t("payment_success.title")}
        </p>

        <p className="text-gray-600 text-center mb-6">
          {t("payment_success.description")}
        </p>

        <Button
          type="primary"
          className="hidden sm:flex bg-primary-lightyellow hover:bg-primary-yellow text-primary-blue border-none p-6 rounded-3xl"
          onClick={() => navigate(path.HOME)}
        >
          {t("cta.back_to_home")}
        </Button>
      </div>
    </div>
  );
};

export default PaymentComplete;
